"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileCompactCTABanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const index_1 = require("../index");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const MobileCompactCTABanner_module_css_1 = __importDefault(require("./MobileCompactCTABanner.module.css"));
const attribution_1 = require("../../attribution");
/**
 * Mobile Compact CTA Banner
 */
function MobileCompactCTABanner({ downloadLink, link, onClick, openInSnapchatLink, }) {
    return ((0, jsx_runtime_1.jsxs)("a", { className: MobileCompactCTABanner_module_css_1.default.mobileCompactCtaBanner, href: (0, attribution_1.getMobileAttributionLink)({
            oneLink: link,
            openInAppLink: openInSnapchatLink,
            downloadLink,
        }), onClick: onClick, children: [(0, jsx_runtime_1.jsx)(web_core_ui_1.GhostIconWithCircularBg, { width: 24, height: 24 }), (0, jsx_runtime_1.jsx)(index_1.CTABannerMessage, { openInSnapchatLink: openInSnapchatLink })] }));
}
exports.MobileCompactCTABanner = MobileCompactCTABanner;
//# sourceMappingURL=MobileCompactCTABanner.js.map